import { Button } from 'components/Button/Button';
import { MouseEvent } from 'react';

type Props = {
  clickHandler: (e: MouseEvent<HTMLElement>) => void;
  isDisabled: boolean;
  isLoading: boolean;
  submitButtonText: string;
  /** Shows a Back button (DealsAway, where Traveller comes before Rooms). */
  backHandler?: () => void;
};

const RoomSubmit = ({
  clickHandler,
  isDisabled,
  isLoading,
  submitButtonText,
  backHandler,
}: Props) => {
  return (
    <div
      className={
        'flex p-5 bg-light-700 rounded-md ' +
        (backHandler ? 'justify-between items-center gap-5' : 'justify-end')
      }
    >
      {backHandler && (
        <Button
          text="Back"
          clickHandler={backHandler}
          isDisabled={isLoading}
          size="medium"
          type="secondary-border"
          arrow="left"
          className="min-w-[6.25rem]"
          textClassName="!text-sm"
        />
      )}
      <Button
        text={submitButtonText}
        clickHandler={clickHandler}
        size="medium"
        type="primary"
        isDisabled={isDisabled}
        isLoading={isLoading}
        arrow="right"
        className="min-w-[15.625rem]"
      />
    </div>
  );
};

export { RoomSubmit };
